/**
 * Waitlist Service - Handles submission to the waitlist using server API
 * This avoids requiring users to log in to Microsoft
 */

// Define the FormData interface
export interface FormData {
  name: string;
  email: string;
  phone: string;
  referredBy: string;
  consentToContact: boolean;
}

// API URL with environment-aware fallback
const API_URL = import.meta.env.VITE_API_URL || 
  // Use the original domain that was working before
  (import.meta.env.PROD ? 'https://wait-list-api.vercel.app' : 'http://localhost:3001');

/**
 * Submit waitlist data to the server API
 * @param data Form data to submit
 * @param platformName Platform name (InvyteOut or Vynterface)
 * @returns Promise that resolves to true if successful
 */
export const submitWaitlistData = async (
  data: FormData,
  platformName: string
): Promise<boolean> => {
  try {
    // In development mode with DEV_MODE=true, simulate a successful submission
    if (process.env.NODE_ENV === 'development' && import.meta.env.VITE_DEV_MODE === 'true') {
      await new Promise(resolve => setTimeout(resolve, 800));
      return true;
    }
    
    // Submit data to the waitlist API
    
    try {
      const response = await fetch(`${API_URL}/api/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...data,
          platformType: platformName
        })
      });
      
      // Parse the response
      const result = await response.json();
      
      // Check if the operation was successful
      if (result.success) {
        return true;
      }
      
      // If not successful, throw an error with the message from the server
      throw new Error(result.message || 'Failed to submit waitlist data');
    } catch (error) {
      // Log a generic error message without exposing details
      console.error('Error submitting to waitlist');
      throw error;
    }
    

  } catch (error) {
    // In development mode, simulate success despite the error
    if (process.env.NODE_ENV === 'development' && import.meta.env.VITE_DEV_MODE === 'true') {
      return true;
    }
    
    throw error;
  }
};
